

import React, { useState, useEffect } from "react";


const CountdownTimer = ({ contestDetails, setcontestError, setcontestErrormsg, setenddateError,lang }) => {
  let data = JSON.parse(contestDetails.date_differnce);
  //console.log(data.time_diff);
  const [timeLeft, setTimeLeft] = useState(data.time_diff);
  // Function to convert seconds into a readable time format
  const convertToTimeFormat = (seconds) => {
    const days = Math.floor(seconds / (60 * 60 * 24));
    const hours = Math.floor((seconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((seconds % (60 * 60)) / 60);
    const remainingSeconds = seconds % 60;

    return { days, hours, minutes, remainingSeconds };
  };

  useEffect(() => {
    if (timeLeft <= 0) {
      setenddateError(1);
      //setcontestError(1);
      setcontestErrormsg("This Contest has ended. Congratulations to all the winners!");
      return;

    }


    const interval = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval when the countdown finishes or on unmount
  }, [timeLeft, setcontestError, setcontestErrormsg, setenddateError]); // Add `timeLeft` to the dependency array to trigger effect when timeLeft updates

  const formattedTime = convertToTimeFormat(timeLeft);

  return (
    <div className="flex items-center justify-center md:mt-5 relative">
      <div className="bg-white absolute md:w-[653px] md:h-[108px] rounded-lg shadow-md border border-gray-200 px-4 pb-4 min-w-[280px] mt-[55px] md:mt-[10px]">
        <div className="text-center text-[#8A8181] text-sm md:text-sm font-semibold mb-2 mt-2">
            {lang?.hours_left || 'Hours Left'}
        </div>

        <div className="grid grid-cols-4 gap-4 text-center">
          <div className="flex flex-col items-center border-r-2 pr-2">
            <span className="md:text-3xl text-2xl font-bold">{formattedTime.days}</span>
            <span className="text-[#8A8181] text-[13px] md:text-[18px] leading-[22px] tracking-normal">{lang?.days || 'DAYS'}</span>
          </div>
          <div className="flex flex-col items-center border-r-2 pr-2">
            <span className="md:text-3xl text-2xl font-bold">{formattedTime.hours}</span>
            <span className="text-[#8A8181] text-[13px] md:text-[18px] leading-[22px] tracking-normal">{lang?.hours || 'HOURS'}</span>
          </div>
          <div className="flex flex-col items-center border-r-2 pr-3">
            <span className="md:text-3xl text-2xl font-bold">{formattedTime.minutes}</span>
            <span className="text-[#8A8181] text-[13px] md:text-[18px] leading-[22px] tracking-normal">{lang?.minutes || 'MINUTES'}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="md:text-3xl text-2xl font-bold">{formattedTime.remainingSeconds}</span>
            <span className="text-[#8A8181] text-[13px] md:text-[18px] leading-[22px] tracking-normal">{lang?.seconds || 'SECONDS'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;


